export default "__VITE_ASSET__BIoz5kFG__"